import useRingFeature from '../../hooks/useRingFeature';

const useRealTimeMeetingsEnabled = (eventUniqueName: string) => {
    return useRingFeature(eventUniqueName, 'videoMeetings');
};

export default useRealTimeMeetingsEnabled;
